import View from "./view";
import Presenter from "./presenter";
import { ConnectComponent2 } from "util";

const states = [
  {
    name: "app.history.dashboard",
    url: "/painel-de-resultados",
    views: {
      "content@app": ConnectComponent2(View, Presenter)
    },
    data: {
      navigation: {
        name: "Painel de Resultados",
        priority: 100,
        //authorization: (context => context.user.permissions.includes('view_closed_sales')),
        authorization: () => true,
        state: "app.history.dashboard"
      }
    }
  }
];

export { states };



// WEBPACK FOOTER //
// ./src/components/app/history/dashboard/index.js